



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class FilterToggle extends Vue {
  @Prop({ type: String })
  filterId!: string;

  @Prop({ type: Boolean })
  filterIsOpen!: boolean;

  @Prop({ type: Number })
  resultCount!: number;

  private clickedButton () {
    this.$emit('clickedbutton')
  }
}
